import { InventoryApis } from "../apis/InventoryApis";

export const InventoryServices = {
  fetchInventory: async () => {
    const response = await InventoryApis.fetchInventory();
    return response;
  },

  fetchCollectionByTitle: async (title) => {
    const response = await InventoryApis.fetchCollectionByTitle(title);
    if (!response.status !== 200) {
      return {
        message: response.message,
        data: response.data,
        success: response.success,
        status: response.status,
      };
    }
    return {
      message: response.message,
      data: response.data,
      success: response.success,
      status: response.status,
    };
  },

  addNewProduct: async (formDataToSend) => {
    const response = await InventoryApis.addNewProduct(formDataToSend);
    return response;
  },

  logProductPayload: async (payload) => {
    const response = await InventoryApis.logProductPayload(payload);
    return response;
  },

  updateProduct: async (productId, formDataToSend) => {
    const response = await InventoryApis.updateProduct(
      productId,
      formDataToSend,
    );
    return response;
  },

  deleteItem: async (productId) => {
    const response = await InventoryApis.deleteItem(productId);
    if (!response.success) {
      return {
        success: response.success,
        status: response.status,
        message: response.message || "Something went wrong",
      };
    }
    return {
      success: response.success,
      status: response.status,
      data: response.data,
    };
  },
};
